import { object, string } from "yup";

import { isEmail } from "@logics/utils/validationHandler";

import { MIN_PASSWORD_LENGTH } from "./formLimit";
import { AUTH_ERROR_TEXT, NO_ERROR_MESSAGE } from "./authWords";

const emailSchema = string()
  .required(NO_ERROR_MESSAGE)
  .test("isValid", AUTH_ERROR_TEXT.EMAIL.WRONG_PATTERN, (value) =>
    isEmail(value),
  );

export const authEntrySchema = object({
  email: emailSchema,
});

export const loginSchema = object({
  email: emailSchema,
  password: string().required(NO_ERROR_MESSAGE),
});

export const signupSchema = object({
  email: emailSchema,
  password: string()
    .required(NO_ERROR_MESSAGE)
    .min(MIN_PASSWORD_LENGTH, NO_ERROR_MESSAGE),
});
